<!--60  FixClassification-->
<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Fehlende Features hinzufügen' | translate }}</div>
  <dx-switch [(value)]="addMissingFeatures"></dx-switch>
</div>

